<template>
  <div class="login">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>商城后台管理系统</span>
      </div>
      <el-form label-width="50px">
        <el-form-item>
          账号：<el-input type="text" v-model="username"></el-input>
          密码：<el-input type="password" v-model="password" class="pwd"></el-input>
          <el-button type="primary" @click="handlelogin()">登录</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: '',//admin
      password: ''//root
    }
  },
  mounted() {
    // console.log(document.cookie);
    // if (
    //   document.cookie ===
    //   "_legacy_auth0.Aaj2RxJGoEI7pZziQ0rEUgtFAhM1nzEX.is.authenticated=true; auth0.Aaj2RxJGoEI7pZziQ0rEUgtFAhM1nzEX.is.authenticated=true"
    // ) {
    //   this.$router.push({ path: "/home" });
    // }
  },
  methods: {
    handlelogin() {
      // this.$auth.loginWithRedirect();
      if((this.username == 'cw' && this.password == 'mQ7!tV9#pL2@xR6$') ||
      (this.username == 'ym' && this.password == 'r5@G!2xQ#9Lm$7Vp') ||
      (this.username == 'cn' && this.password == 'Z8$kN3!qT6@vP1#s') ||

      (this.username == 'hjx' && this.password == 'H3#tq9$V!6nR2@xK') ||
      (this.username == 'wlc' && this.password == 'K4!p$8Vx@2rQ#9mL') ||

      (this.username == 'zhangshifan77' && this.password == 'c3$M@8p!Q6#rT2xV') ||
      (this.username == 'ywkerp' && this.password == '7x@L#2m!P9$Q4rTv') ||
      (this.username == 'zq' && this.password == 'h8#Q@1v!M6$kR3xP') ||
      (this.username == 'guoqiu' && this.password == 'W9#k@4R!m2$Q7xLp') ||
          (this.username == 'jsh' && this.password == '9R$e!A6xM@4kP#2q') ||

          (this.username == 'xzx' && this.password == 'n6@T!3qP#8Lm$5Rx') ||
      (this.username == 'zmj' && this.password == 't7#Q@9m!L2$wR6xP')){
        window.localStorage.setItem('un',this.username);
        this.$router.push({ path: "/home/orderlist" });
        // document.cookie=this.username;
      }else if(this.username == '' || this.password == ''){
        this.$message({
          message: '账号或密码不能为空',
          type: 'warning'
        });
      }else if((this.username != 'cw' && 
      this.username != 'ym' &&
      this.username != 'cn' &&
      this.username != 'hjx' && 
      this.username != 'wlc' &&
      this.username != 'zhangshifan77' &&
      this.username != 'ywkerp' &&
      this.username != 'zq' && 
      this.username != 'guoqiu' &&
      this.username != 'xyz' &&
      this.username != 'xzx' &&
      this.username != 'zmj') ||
      (this.password != 'mQ7!tV9#pL2@xR6$' &&
      this.password != 'r5@G!2xQ#9Lm$7Vp' &&
      this.password != 'Z8$kN3!qT6@vP1#s' &&
      this.password != 'H3#tq9$V!6nR2@xK' &&
      this.password != 'K4!p$8Vx@2rQ#9mL' &&
      this.password != 'c3$M@8p!Q6#rT2xV' &&
      this.password != '7x@L#2m!P9$Q4rTv' &&
      this.password != 'h8#Q@1v!M6$kR3xP' &&
      this.password != 'W9#k@4R!m2$Q7xLp' &&
      this.password != '9R$e!A6xM@4kP#2q' &&
      this.password != 'n6@T!3qP#8Lm$5Rx' &&
      this.password != 't7#Q@9m!L2$wR6xP')){
        this.$message({
          message: '账号或密码输入错误',
          type: 'error'
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pwd{
  margin-bottom: 20px;
}
.login {
  width: 100%;
  height: 100%;
  position: absolute;
  background: #409eff;
  .box-card {
    width: 450px;
    margin: 200px auto;
    span {
      font-size: 30px;
      font-weight: bolder;
    }
    .el-button {
      width: 100%;
    }
  }
}
.clearfix {
  padding-left: 30px;
  text-align: center;
}
.el-form,
.clearfix {
  margin-right: 30px;
}
</style>